/**
 * Auto-generated API Client
 *
 * Generated by @spfn/core codegen
 * DO NOT EDIT MANUALLY
 *
 * @generated 2025-11-03T13:40:07.038Z
 */

import { client } from '@spfn/core/client';
import type { InferContract } from '@spfn/core';

import { getPublishedCacheContract, upsertPublishedCacheContract } from '@/lib/contracts/published-cache';

// ============================================
// Types
// ============================================

export type GetPublishedCacheResponse = InferContract<typeof getPublishedCacheContract>['response'];
export type GetPublishedCacheQuery = InferContract<typeof getPublishedCacheContract>['query'];

export type UpsertPublishedCacheResponse = InferContract<typeof upsertPublishedCacheContract>['response'];
export type UpsertPublishedCacheBody = InferContract<typeof upsertPublishedCacheContract>['body'];

// ============================================
// API Functions
// ============================================

/**
 * GET /_cms/published-cache
 */
export const getPublishedCache = (options: { query?: GetPublishedCacheQuery }) => client.call(getPublishedCacheContract, options);

/**
 * POST /_cms/published-cache
 */
export const upsertPublishedCache = (options: { body: UpsertPublishedCacheBody }) => client.call(upsertPublishedCacheContract, options);

